module.exports = __webpack_public_path__ + "static/img/illustration-forgot-password-dark.2d54a42d.png";